import React from "react";
import { connect } from "react-redux";

import { getRecentMessages, isMessagesLoading } from "state/teachers/selectors";

import Gate from "components/Gate";
import Preloader from "components/app/home/Preloader";
import Message from "components/app/home/sections/teachers/Message";

// number of messages to display
const MESSAGE_COUNT = 3;

class RecentMessages extends React.Component {
  
  renderPlaceholder() {
    return (
      <div className="home-section-placeholder">
        There are currently no messages to display.
      </div>
    )
  }
  
  render() {
    return (
      <div className="home-section teachers-home-messages">
        <div className="home-section-heading home-section-heading--teachers teachers-home-messages__heading">Recent Messages</div>
        <Preloader isLoading={this.props.isMessagesLoading}>
          <Gate isOpen={this.props.messages.size > 0} placeholder={this.renderPlaceholder()}>
            <div className="teachers-home-messages__body">
              {
                this.props.messages.map(message => (
                  <Message key={message.get("id")} message={message} />
                ))
              }
            </div>
          </Gate>
        </Preloader>
      </div>
    )
  }
  
}

export default connect(
  state => ({
    messages: getRecentMessages(state, MESSAGE_COUNT),
    isMessagesLoading: isMessagesLoading(state)
  })
)(RecentMessages);



// WEBPACK FOOTER //
// ./src/components/app/home/sections/teachers/RecentMessages.js